module.exports = __webpack_public_path__ + "img/demand.ebe7c021.svg";